/**
 * Kategori-baseret fallback-motif til billeder der mangler eller fejler.
 * Bruges af EditorialImage (og direkte i ArticleCard/VideoCard) så tomme
 * billed-huller erstattes af et roligt motif i stedet for grå baggrund.
 */
import mad from "@/assets/motifs/mad.png";
import vin from "@/assets/motifs/vin.png";
import have from "@/assets/motifs/have.png";
import cykling from "@/assets/motifs/cykling.png";
import boger from "@/assets/motifs/boger.png";
import kultur from "@/assets/motifs/kultur.png";
import kunst from "@/assets/motifs/kunst.png";
import musik from "@/assets/motifs/musik.png";
import poesi from "@/assets/motifs/poesi.png";
import levekunst from "@/assets/motifs/levekunst.png";
import forsiden from "@/assets/motifs/forsiden.png";

export const MOTIF: Record<string, string> = {
  mad,
  vin,
  have,
  cykling,
  boger,
  kultur,
  kunst,
  musik,
  poesi,
  levekunst,
  forsiden,
  // aliaser
  stemme: kultur,
  bog: boger,
  litteratur: poesi,
  film: kultur,
  arkitektur: kultur,
  rejser: kultur,
  haandvaerk: kunst,
};

export type MotifKind = "article" | "recipe" | "video" | "strejf" | "generic";

export function getMotifFallback(kind: MotifKind, category?: string | null): string {
  if (category) {
    const key = category.toLowerCase();
    if (MOTIF[key]) return MOTIF[key];
  }
  if (kind === "recipe") return MOTIF.mad;
  if (kind === "video") return MOTIF.kultur;
  return MOTIF.forsiden;
}
